import {
  ButtonItem,
  Form,
  Item,
  Label,
  RequiredRule,
} from "devextreme-react/form";
import { LookupTypes } from "devextreme-react/lookup";
import { Popup } from "devextreme-react/popup";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { changeEmailAdmin } from "../../api/auth";
import { downloadUsersToChangePassword } from "../../api/settings";
import "./ChangeUserEmail.scss";

export const ChangeEmailByAdmin = () => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [newEmail, setNewEmail] = useState<string>("");
  const [userId, setUserId] = useState<number | null>(null);
  const [users, setUsers] = useState<{ id: number; email: string }[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isModalVisible) {
      const fetchUsers = async () => {
        try {
          const response = await downloadUsersToChangePassword();

          if (response.data && Array.isArray(response.data)) {
            setUsers(response.data);
          } else {
            const usersList = response.data.data || [];
            setUsers(usersList);
          }
        } catch (err) {
          console.error("Error when try download users data", err);
        }
      };
      fetchUsers();
    }
  }, [isModalVisible]);

  useEffect(() => {}, [users]);

  const handlePopup = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const handleSuccessModalClose = () => {
    setIsSuccessModalVisible(false);
  };

  const handleChangePassword = async () => {
    if (!userId) {
      alert(t("Please select a user"));
      return;
    }

    setIsLoading(true);
    try {
      const response = await changeEmailAdmin(userId, newEmail);
      if (response.isOk) {
        setIsModalVisible(false);
        setIsSuccessModalVisible(true);
      } else {
        setError(
          response.error || t("An error occurred while changing the password.")
        );
        setIsModalVisible(false);
        setIsSuccessModalVisible(true);
      }
    } catch (error) {
      setError(t("An error occurred while changing the password."));
      setIsModalVisible(false);
      setIsSuccessModalVisible(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="change-email">
      <h1>{t("Change email users")}</h1>
      <p>
        {t(
          "On this page, you can change the email for your organization's user account"
        )}
      </p>
      <button className="change-email-button" onClick={handlePopup}>
        {t("Change email")}
      </button>

      <Popup
        visible={isModalVisible}
        onHiding={handleCloseModal}
        maxWidth={300}
        height="auto"
        maxHeight="80vh"
        title={t("Change your email")}
        showCloseButton
        dragEnabled
      >
        <Form>
          <Item
            dataField="userId"
            editorType="dxLookup"
            editorOptions={
              {
                items: users,
                displayExpr: "email",
                valueExpr: "id",
                width: 250,
                value: userId,
                onValueChanged: (e: any) => setUserId(e.value),
                placeholder: t("Select a user"),
                dropDownOptions: {
                  height: 300,
                  showScrollbar: "onHover",
                  hideOnOutsideClick: true,
                  showTitle: false,
                },
              } as LookupTypes.Properties
            }
          >
            <RequiredRule message={t("User selection is required")} />
            <Label text={t("User")} />
          </Item>

          <Item
            editorType="dxTextBox"
            editorOptions={{
              value: newEmail,
              onValueChanged: (e: any) => setNewEmail(e.value),
              placeholder: t("Enter your new email"),
              mode: "email",
            }}
          >
            <RequiredRule message={t("New emial is required")} />
            <Label text={t("New email")} />
          </Item>
          <ButtonItem
            buttonOptions={{
              text: t("Send"),
              type: "default",
              onClick: handleChangePassword,
              disabled: isLoading,
            }}
          />
        </Form>
      </Popup>

      <Popup
        visible={isSuccessModalVisible}
        onHiding={handleSuccessModalClose}
        maxWidth={400}
        height="auto"
        maxHeight="80vh"
        title={t("Email change status")}
        showCloseButton
        dragEnabled
      >
        <div className="success-content">
          {error ? (
            <p className="error-message">{error}</p>
          ) : (
            <p>{t("Email change was successful")}</p>
          )}
        </div>
      </Popup>
    </div>
  );
};
